import { render } from "./MonacoEditorFreeSpace.vue?vue&type=template&id=2a9c2f48&ts=true"
import script from "./MonacoEditorFreeSpace.vue?vue&type=script&lang=ts"
export * from "./MonacoEditorFreeSpace.vue?vue&type=script&lang=ts"

import "./MonacoEditorFreeSpace.vue?vue&type=style&index=0&id=2a9c2f48&lang=postcss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__